export const betModels = {
  bookmaker: [
    { name: 'win', selected: false, type: 'bookmaker' },
    { name: 'place', selected: false, type: 'bookmaker' },
    { name: 'Win/Place', selected: false, type: 'bookmaker' },
    { name: 'ita', selected: false, type: 'bookmaker' },
    { name: 'trita', selected: false, type: 'bookmaker' },
    { name: 'quinella', selected: false, type: 'bookmaker' },
    { name: 'trifecta', selected: false, type: 'bookmaker' },
    { name: '', selected: false, type: 'bookmaker' },
    { name: '', selected: false, type: 'bookmaker' },
    { name: '', selected: false, type: 'bookmaker' },
    { name: '', selected: false, type: 'bookmaker' },
    { name: '', selected: false, type: 'bookmaker' },
  ],
  fixedOdds: [
    { name: 'win', selected: false, type: 'fixedOdds' },
    { name: 'win/place', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
    { name: '', selected: false, type: 'fixedOdds' },
  ],
  racingClub: [
    { name: 'win', selected: false, type: 'racingClub' },
    { name: 'place', selected: false, type: 'racingClub' },
    { name: 'ita', selected: false, type: 'racingClub' },
    { name: 'trita', selected: false, type: 'racingClub' },
    { name: 'quinella', selected: false, type: 'racingClub' },
    { name: 'trifecta', selected: false, type: 'racingClub' },
    { name: '', selected: false, type: 'racingClub' },
    { name: '', selected: false, type: 'racingClub' },
    { name: '', selected: false, type: 'racingClub' },
    { name: '', selected: false, type: 'racingClub' },
    { name: '', selected: false, type: 'racingClub' },
    { name: '', selected: false, type: 'racingClub' },
  ],
  stakes: [0.5, 1.0, 1.5, 2.0, 2.5, 5.0, 10.0, 20.0, 50.0, 100.0, 200.0, 500.0],
  betOddParameters: [
    { betType: 'bm', bet: 'win', parameterName: 'StartingPrice' },
    { betType: 'bm', bet: 'show', parameterName: 'StartingPrice' },
    { betType: 'bm', bet: 'win_show', parameterName: 'StartingPrice' },
    { betType: 'fo', bet: 'win', parameterName: 'WinOdd' },
    { betType: 'fo', bet: 'win_show', parameterName: 'winPlaceOdd' },
  ],
};
